import { generateStyle } from './generateStyle';
import components from './base/components';
import variables from './base/variables';

export default generateStyle({
  components,
  variables,
});
